import types from '../../types';

export default {
  [types.STORE_ITEMS]: (state, payload) => {
    state.shipmentContentItems = {
      items: payload.items,
      count: payload.count,
      entity: payload.entity,
    };
  },
  [types.CLEAR_ITEMS]: (state) => {
    state.shipmentContentItems = {
      items: [],
      count: '',
      entity: {},
    };
  },
  [types.STORE_ITEM]: (state, payload) => {
    state.shipmentContentItem = payload;
  },
};
